import { render, staticRenderFns } from "./GraphCard.vue?vue&type=template&id=11f2b167&scoped=true&"
import script from "./GraphCard.vue?vue&type=script&lang=ts&"
export * from "./GraphCard.vue?vue&type=script&lang=ts&"
import style0 from "./GraphCard.vue?vue&type=style&index=0&id=11f2b167&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f2b167",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VSkeletonLoader})
